"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DistanceIcon = DistanceIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function DistanceIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M11.4621 11.8455C11.1792 11.6098 11.141 11.1894 11.3767 10.9066L13.2433 8.66668H2.75669L4.62325 10.9066C4.85896 11.1894 4.82074 11.6098 4.53789 11.8455C4.25504 12.0812 3.83466 12.043 3.59895 11.7601L0.821175 8.42681C0.61515 8.17958 0.61515 7.82046 0.821175 7.57323L3.59895 4.23989C3.83466 3.95704 4.25504 3.91883 4.53789 4.15454C4.82074 4.39025 4.85896 4.81062 4.62325 5.09347L2.75669 7.33335H13.2433L11.3767 5.09347C11.141 4.81062 11.1792 4.39025 11.4621 4.15454C11.7449 3.91883 12.1653 3.95704 12.401 4.23989L15.1788 7.57323C15.3848 7.82046 15.3848 8.17958 15.1788 8.42681L12.401 11.7601C12.1653 12.043 11.7449 12.0812 11.4621 11.8455Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}